/**
 *  @class
 *  @function FreeShipping
 */

if (!customElements.get('free-shipping')) {
  class FreeShipping extends HTMLElement {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.initialize();
      
      // Listen for cart update events
      document.addEventListener('line-item:change:end', this.handleCartUpdate.bind(this));
      
      // Also listen for page load to ensure correct initialization
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.initialize.bind(this));
      }
    }
    
    disconnectedCallback() {
      // Clean up event listeners
      document.removeEventListener('line-item:change:end', this.handleCartUpdate.bind(this));
    }
    
    handleCartUpdate(event) {
      // Update the component with new cart data
      if (event.detail && event.detail.cart) {
        this.updateWithCartData(event.detail.cart);
      } else {
        // If no cart data provided, try to reinitialize with current dataset
        setTimeout(() => {
          this.initialize();
        }, 100);
      }
    }
    
    updateWithCartData(cartData) {
      const total = cartData.total_price;
      const minimum = Math.round(parseInt(this.dataset.minimum, 10) * (Shopify.currency.rate || 1));
      
      // Update the dataset with new cart total
      this.dataset.cartTotal = total;
      
      this.updateDisplay(total, minimum);
    }
    
    initialize() {
      let total = parseInt(this.dataset.cartTotal, 10);
      let minimum = Math.round(parseInt(this.dataset.minimum, 10) * (Shopify.currency.rate || 1));
      
      // Ensure we have valid data
      if (isNaN(total) || isNaN(minimum)) {
        console.warn('Free shipping component: Invalid cart total or minimum', { total, minimum });
        return;
      }
      
      this.updateDisplay(total, minimum);
    }
    
    updateDisplay(total, minimum) {
      let amount_text = this.querySelector('.free-shipping--text span');
      let percentage = 1;
      this.remainingText = this.querySelector('.free-shipping--text-remaining');
      this.fullText = this.querySelector('.free-shipping--text-full');
      
      if (total < minimum) {
        percentage = total / minimum;

        if (amount_text) {
          let remaining = minimum - total,
            format = window.theme.settings.money_with_currency_format || "${{amount}}";
          amount_text.innerHTML = formatMoney(remaining, format);
        }
        this.remainingText.style.display = 'block';
        this.fullText.style.display = 'none';
      } else {
        this.remainingText.style.display = 'none';
        this.fullText.style.display = 'block';
      }

      this.style.setProperty('--percentage', percentage);
    }
  }
  customElements.define('free-shipping', FreeShipping);
}

// Ensure all free shipping components are initialized when the page loads
document.addEventListener('DOMContentLoaded', () => {
  const freeShippingComponents = document.querySelectorAll('free-shipping');
  freeShippingComponents.forEach(component => {
    if (component.initialize) {
      component.initialize();
    }
  });
});

// Also listen for cart refresh events
document.addEventListener('cart:refresh', () => {
  setTimeout(() => {
    const freeShippingComponents = document.querySelectorAll('free-shipping');
    freeShippingComponents.forEach(component => {
      if (component.initialize) {
        component.initialize();
      }
    });
  }, 200);
});